import { Grid as MuiGrid } from '@mui/material';

import { BasetenPageEnum } from '@/routes';

import GridCardWrapper from '../../sections/GridCardWrapper';
import { ListProps } from '../types';
import Card from './Card';

function Grid({ orgSharedEndpoints, isSpendExceeded }: ListProps) {
  return (
    <MuiGrid container spacing={3} px={4} py={2}>
      {orgSharedEndpoints.map((orgSharedEndpoint) => (
        <GridCardWrapper<BasetenPageEnum.SharedEndpoint>
          linkParams={{
            page: BasetenPageEnum.SharedEndpoint,
            params: { sharedEndpointId: orgSharedEndpoint.id },
          }}
          key={orgSharedEndpoint.id}
          alwaysVisible={orgSharedEndpoints.length < 35}
        >
          <Card orgSharedEndpoint={orgSharedEndpoint} isSpendExceeded={isSpendExceeded} />
        </GridCardWrapper>
      ))}
    </MuiGrid>
  );
}

export default Grid;
